import { API_KEY, API_URL } from './config.js';
import { AJAX } from './helpers.js';
import { RESULTS_PER_PAGE } from './config.js';

export const state = {
  recipe: {},
  search: {
    query: '',
    results: [],
    page: 1,
    resultsPerPage: RESULTS_PER_PAGE,
  },
  bookmarks: [],
};

const createRecipeObject = function (data) {
  const { recipe } = data.data;
  return {
    id: recipe.id,
    title: recipe.title,
    publisher: recipe.publisher,
    sourceURL: recipe.source_url,
    image: recipe.image_url,
    servings: recipe.servings,
    cokingTime: recipe.cooking_time,
    ingredients: recipe.ingredients,
    ...(recipe.key && { key: recipe.key }),
  };
};

export const loadRecipe = async function (recipeID) {
  try {
    const data = await AJAX(`${API_URL}/${recipeID}?key=${API_KEY}`);
    state.recipe = createRecipeObject(data);

    if (state.bookmarks.some(bookmark => bookmark.id === state.recipe.id)) {
      state.recipe.bookmarked = true;
    } else {
      state.recipe.bookmarked = false;
    }
  } catch (error) {
    throw error;
  }
};

export const loadSearchResults = async function (query) {
  try {
    state.search.query = query;
    const data = await AJAX(`${API_URL}?search=${query}&key=${API_KEY}`);
    state.search.results = data.data.recipes.map(recipe => {
      return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        image: recipe.image_url,
        ...(recipe.key && { key: recipe.key }),
      };
    });
  } catch (error) {
    throw error;
  }
};

export const getSearchResultsPage = function (page = state.search.page) {
  state.search.page = page;
  const start = (page - 1) * state.search.resultsPerPage;
  const end = page * state.search.resultsPerPage;
  return state.search.results.slice(start, end);
};

export const updateServings = function (adjustedServings) {
  state.recipe.ingredients.forEach(ingredient => {
    if (!ingredient.quantity) return;
    ingredient.quantity =
      (ingredient.quantity * adjustedServings) / state.recipe.servings;
  });
  state.recipe.servings = adjustedServings;
};

const persistBookmarks = function () {
  localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
};

export const addBookmark = function (recipe) {
  state.bookmarks.push(recipe);
  if (recipe.id === state.recipe.id) {
    state.recipe.bookmarked = true;
  }

  persistBookmarks();
};

export const removeBookmark = function (recipe) {
  const index = state.bookmarks.findIndex(element => element.id === recipe.id);
  state.bookmarks.splice(index, 1);
  if (recipe.id === state.recipe.id) {
    state.recipe.bookmarked = false;
  }

  persistBookmarks();
};

export const uploadRecipe = async function (newRecipe) {
  try {
    const quantities = Object.entries(newRecipe)
      .filter(entry => entry[0].startsWith('quantity'))
      .map(entry => [entry[0], entry[1].trim()]);
    const units = Object.entries(newRecipe)
      .filter(entry => entry[0].startsWith('unit'))
      .map(entry => [entry[0], entry[1].trim()]);
    const descriptions = Object.entries(newRecipe)
      .filter(entry => entry[0].startsWith('description'))
      .map(entry => [entry[0], entry[1].trim()]);
    const ingredients = ['', '', '', '', '', '']
      .map((_, index) => {
        return {
          quantity:
            isFinite(quantities[index][1]) && quantities[index][1] != ''
              ? Number(quantities[index][1])
              : null,
          unit: units[index][1],
          description: descriptions[index][1],
        };
      })
      .filter(ingredient => ingredient.description != '');

    const recipe = {
      title: newRecipe.title,
      source_url: newRecipe.sourceUrl,
      image_url: newRecipe.image,
      publisher: newRecipe.publisher,
      cooking_time: Number(newRecipe.cookingTime),
      servings: Number(newRecipe.servings),
      ingredients,
    };
    const data = await AJAX(`${API_URL}/?key=${API_KEY}`, recipe);
    state.recipe = createRecipeObject(data);
    addBookmark(state.recipe);
  } catch (error) {
    throw new Error(error.message);
  }
};

(function init() {
  const storage = localStorage.getItem('bookmarks');
  if (storage) {
    state.bookmarks = JSON.parse(storage);
  }
})();
